import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, Slide, Typography, Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteRoleModal = ({ open, role, isLoading, handleClose, handleConfirm }) => {
    if (!role) return null;
    return (
        <Dialog open={open} onClose={isLoading ? undefined : handleClose} TransitionComponent={Transition}
            maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: 'white' }}>
                <DialogTitle sx={{ p: 2.5 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Icon icon="mdi:alert-circle-outline" width="26" height="26" />
                            <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>Delete Employee Type</Typography>
                        </Box>
                        <IconButton onClick={handleClose} disabled={isLoading} size="small"
                            sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.15)' }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </DialogTitle>
            </Box>
            <DialogContent sx={{ p: 2.5, textAlign: 'center', bgcolor: '#f8fafc' }}>
                <Icon icon="mdi:alert-outline" width="52" height="52" style={{ color: '#ef4444', opacity: 0.85 }} />
                <Typography variant="body1" sx={{ fontWeight: 600, my: 1 }}>
                    Delete “{role.type}”?
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    The type is soft-deleted (status set to Deleted). Existing employees keep their reference.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                <Button onClick={handleClose} disabled={isLoading} variant="outlined"
                    sx={{ borderColor: 'rgba(0,0,0,0.23)', color: 'text.primary' }}>Cancel</Button>
                <Button onClick={handleConfirm} disabled={isLoading} variant="contained"
                    sx={{ backgroundColor: '#ef4444', '&:hover': { backgroundColor: '#dc2626' } }}>
                    {isLoading ? 'Deleting…' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteRoleModal;
